<template lang="pug">
	content-page
		div(slot="nav")
			navigation-default
		div
			h1 {{contentpage.name}}
			ws-content(:value="contentpage.content")
				template(slot="countries")
					template(v-for="country in countries")
						v-row
							v-col.shrink
								v-card
									nuxt-link(:to="localePath({name: 'areas-countries-country', params: { country: country.slug} })")
										img.ma-0.flag.xl(:src="`https://static.wintersport.nl/images/flags/svg/${country.countryCode}.svg`" :alt="country.name")
							v-col.grow
								h2.title
									nuxt-link(:to="localePath({name: 'areas-countries-country', params: { country: country.slug} })") {{country.name}}
								ws-icon.mr-2 peak-height
								| {{$tc('page.areas.countries:area_{count}', country.areasCount, { count: country.areasCount })}}
						v-divider
		div.hidden-sm-and-down(slot="sidebar")
				ad.mb-6
				snow-alarm.mb-6
				offers.mb-6
</template>

<script>
import gql from 'graphql-tag';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import NavigationDefault from '@/components/navigation-default';

const getCountrylist = gql`
	query getCountrylist($path: String, $fallback: String) {
		contentpage(path: $path, fallback: $fallback) {
			id
			name
			slug
			content {
				markdown
			}
			...MetaFragment
		}
		countries(sort: PRIORITY) {
			id
			name
			slug
			countryCode
			areasCount
		}
	}
	${MetaFragment}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/skigebieden/overzicht',
			'nl-BE': '/skigebieden/overzicht',
			'de-DE': '/skigebiete/ubersicht-lander-mit-wintersportgebieten'
		}
	},
	components: {
		NavigationDefault
	},
	layout: 'default',
	asyncData({ app, route }) {
		return app.$graphClient
			.query({
				query: getCountrylist,
				variables: {
					path: route.path,
					fallback: ''
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'areas-countries-01', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.meta(data.contentpage.meta);
				app.ads({ sidebar: { visible: true } });
				app.breadcrumbs({
					[app.i18n.t(`page.areas:heading`)]: { name: 'areas' },
					[app.i18n.t(`page.areas.countries:breadcrumb`)]: {
						name: 'areas-countries'
					}
				});

				return data;
			})
			.catch(app.$destinationNotFoundCatcher)
			.catch(error => {
				return app.httpError(500, null, 'areas-countries-02', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
